'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'clsx';
import PropTypes from 'prop-types';

import Button from 'components/ui/Button';
import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import styles from './PopularSearches.module.scss';

const PopularSearchesItem = ({ text, onItemClick }) => {
    return (
        <li className={styles.item}>
            <Button
                type="button"
                className={styles.itemButton}
                onMouseDown={e => e.preventDefault()}
                onClick={e => onItemClick && onItemClick(e, text)}
            >
                <SvgIcon type="search" className={styles.icon} />
                <Text
                    as="span"
                    className={styles.text}
                    baseTheme="bodySmall"
                    themes={{ medium: 'bodyMedium' }}
                >
                    {text}
                </Text>
            </Button>
        </li>
    );
};

const PopularSearches = ({ items, className, onItemClick, ...rest }) => {
    return (
        <div className={cx(styles.root, className)} {...rest}>
            <Text
                className={styles.label}
                baseTheme="labelSmall"
                themes={{ medium: 'labelMedium' }}
            >
                Popular Searches
            </Text>
            <ul className={styles.list}>
                {items.map((item, index) => (
                    <PopularSearchesItem
                        key={index}
                        text={item}
                        onItemClick={onItemClick}
                    />
                ))}
            </ul>
        </div>
    );
};

PopularSearches.propTypes = {
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
    className: PropTypes.string,
    onItemClick: PropTypes.func,
};

PopularSearchesItem.propTypes = {
    text: PropTypes.string.isRequired,
    onItemClick: PropTypes.func,
};

export default PopularSearches;
